module.exports = __webpack_public_path__ + "static/media/layerTween.38b1fe2c.png";